import agent from "../api/agent";
import { User } from "./AuthServices";
import { Product } from "./ProductService";

export interface CartItem {
  id: number;
  product: Product;
  outlet_id: number;
  quantity: number;
  device_id?: string | null;
  created_at: string;
  updated_at: string;
  user: User;
}

export interface CartPost {
  quantity: number;
  product_id: number;
  outlet_id: number;
  custom_price: string;
}

export interface CartUpdatePost {
  quantity: number;
  cart_id: number;
  device_id?: string;
}

export const addToCart = (req: CartPost) => {
  return agent.Cart.addToCart(req);
};

export const getCartItems = (outlet_id: number) => {
  return agent.Cart.getCart(outlet_id);
};

export const updateCart = (req: CartUpdatePost) => {
  return agent.Cart.updateQuantity(req);
};

export const removeCartItem = (cart_id: number) => {
  return agent.Cart.removeCart(cart_id);
};

export const clearCart = (outlet_id:number) => {
  return agent.Cart.clearCart(outlet_id);
};

export const uploadExcelFile = (formData: FormData) => {
  return agent.Cart.uploadExcel(formData);
};
